import React from 'react'

export const Row = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`flex ${className}`} {...props} />
)
